export default __webpack_public_path__ + "static/media/Techno.a514730c.png";